export const errorMessageExtensions = {
  add: item => `Unable to add ${item}`,
  upload: () => 'Upload Failed',
  download: () => 'Unable to download file',
  update: item => `Unable to update ${item}`,
  delete: item => `Unable to delete ${item}`,
  reject: item => `Unable to reject ${item}`,
  accept: item => `Unable to accept ${item}`,
  pending: item => `Unable to pending ${item}`,
  activate: item => `Unable to activate ${item}`,
  sendEmail: () => 'Unable to send email'
};

export const successMessageExtensions = {
  add: item => `${item} added successfully`,
  upload: item => `${item} successfully uploaded`,
  download: item => `${item} successfully uploaded`,
  update: item => `${item} updated successfully`,
  delete: item => `${item} deleted successfully`,
  reject: item => `${item} rejected successfully`,
  accept: item => `${item} accepted successfully`,
  pending: item => `${item} pendind successfully`,
  activate: item => `${item} activate successfully`,
  sendEmail: () => 'Email sent successfully'
};

export const toastTypes = {
  success: 'success',
  error: 'error',
  message: 'message'
};
